import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

import ScrollHandler from '../ScrollHandler/ScrollHandler';

class Unveil extends PureComponent {
    static propTypes = {
        /** Flag to determine if the component is unveiled. Useful if using Unveil with Redux */
        unveiled: PropTypes.bool,
        /** Function to call if the component is in view.  Defaults to internal code, managing state internally */
        onUnveil: PropTypes.func,
        /** If using this component for a background image, this is the URL to that image */
        backgroundImage: PropTypes.string,
        /** How many pixels before the viewport should the element start loading */
        threshold: PropTypes.number,
        /** CSS min-height for the container - useful to prevent page "jumping" when the content gets loaded in */
        minContainerHeight: PropTypes.string,
        /** Any additional CSS classes */
        className: PropTypes.string
    };

    static defaultProps = {
        unveiled: false,
        minContainerHeight: '1em'
    };

    constructor(props) {
        super(props);

        this.state = {
            className: props.className,
            showChildren: props.unveiled,
            divStyle: {
                minHeight: props.minContainerHeight
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.unveiled && nextProps.unveiled) {
            this.unveil();
        }
    }

    handleLazyLoad = (inView) => {
        if (inView) {
            if (this.props.onUnveil) {
                this.props.onUnveil();
            } else {
                this.unveil();
            }
        }
    }

    unveil() {
        let newState = {
            className: this.props.className,
            showChildren: true,
            divStyle: {
                // reset this now that we have unveiled the content
                minHeight: ''
            }
        };

        if (this.props.backgroundImage) {
            newState.divStyle.backgroundImage = `url("${this.props.backgroundImage}")`;
        }

        this.setState(newState);
    }

    render() {
        const {children, threshold} = this.props;
        const {className, divStyle, showChildren} = this.state;

        // When the unveil state is handled by an outside piece, such as redux, it was tricky to remove the event listeners in ScrollHandler
        // ScrollHandler does remove the listeners on unmount so instead just do not render a ScrollHandler if the component is visible
        return (
            <div className={className} style={divStyle}>
                {showChildren ? children :
                    <ScrollHandler
                        onLazyLoad={this.handleLazyLoad}
                        threshold={threshold}
                        unobserveAfterIntersect
                    />}
            </div>
        );
    }
}

export default Unveil;
